import { IsNotEmpty, IsEnum } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";

export class UpdateEmpAvlLeaves {
    @ApiProperty()
    @IsNotEmpty()
    year: string;
    @ApiProperty()
    @IsNotEmpty({message: 'employeeId should not be empty'})
    employeeId: number;
    @ApiProperty()
    @IsNotEmpty({message: 'Type Of leave should not be empty'})
    typeOfLeave: number;
    @ApiProperty()
    @IsNotEmpty({message: 'Consumed leave should not be empty'})
    consumedLeaves: number;   
    @ApiProperty()
    status: LeaveApprovalStatusEnum;   

}